import { canvasState } from '@diagram/state/canvas';

import { useSnapshot } from 'hooks/use-safe-snapshot';

const useCanvas = () => {
    return useSnapshot(canvasState);
};

export { useCanvas };
